// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('appClosureCharge/getData', async ({ setBlock, ...params }) => {

  setBlock(true)

  params.type = 'charge'

  const response = await axios.get('/apps/charge/closures', params)

  setBlock(false)

  return {
    params,
    dataFiltered : response.data.dataFiltered,
    data         : response.data.closures,
    allData      : response.data.allData,
    totalPages   : response.data.total
  }
})

export const appClosureChargeSlice = createSlice({
  name: 'appClosureCharge',
  initialState: {
    dataFiltered : [],
    data         : [],
    total        : 1,
    params       : {},
    allData      : []
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.dataFiltered = action.payload.dataFiltered
      state.data         = action.payload.data
      state.allData      = action.payload.allData
      state.total        = action.payload.totalPages
      state.params       = action.payload.params
    })
  }
})

export default appClosureChargeSlice.reducer
